<template>
  <div class="ucenter">
    <communityHeader :router_url='router_url'
                     :userId='userId'></communityHeader>
    <div class="hd">
      <!-- 用户信息 -->

      <div class="user _width ">

        <div>
          <Loading :loading_bool="loading_bool"></Loading>
        </div>

        <div v-if="!loading_bool"
             class="user_center _height ">
          <img :src="user_data.backgroundpUrl"
               alt=""
               v-if="user_data.backgroundpUrl"
               class="user_bag ">

          <!-- <img v-else
               src="@/assets/image/common/ta.png"
               alt=""
               class="user_bag"> -->

          <!-- banner的用户信息 -->
          <div class="user_header_menu _width">
            <a href="javascript:;"
               class="header_img">
              <img :src="user_data.headimg"
                   alt="">
            </a>

            <p class="user_name _width">{{user_data.realname}}</p>

            <p class="user_desc _width">{{user_data.comment}}</p>
            <div class="follow_center _width">
              <button class="follow "
                      v-ripple="'rgba(255, 255, 255, 0.25)'"
                      v-if="user_data.isFlow ==0"
                      @click="on_follow(user_data.userId)">
                <div class="_width">+关注</div>
              </button>
              <button class="follow_null hover_foolow"
                      v-ripple="'rgba(255, 255, 255, 0.25)'"
                      @click="deletd_follow(user_data.userId)"
                      v-if="user_data.isFlow == 1">
                <div class="_width">已关注</div>
                <div class="_width top">取消关注</div>

              </button>

            </div>

          </div>
          <!-- banner的用户信息 -->
        </div>
      </div>
      <!-- 用户信息 end-->

      <!-- 导航 -->
      <div class="menu _width">
        <ul class="wrap padding _height">
          <li class="_width _heigth"
              @click="change(0)">作品<span v-if="user_data.topicCount" class="font-style">({{user_data.topicCount}})</span>
            <div :class="menubox== 0 ? 'show_top':''"></div>
          </li>
          <li class="_width _heigth"
              @click="change(1)">圈子<span v-if="user_data.circleCount" class="font-style">({{user_data.circleCount}})</span>
            <div :class="menubox== 1 ? 'show_top':''"></div>
          </li>

          <li class="_width"
              @click="change(2)">影展<span v-if="user_data.photoshowCount" class="font-style">({{user_data.photoshowCount}})</span>
            <div :class="menubox== 2 ? 'show_top':''"></div>
          </li>

          <li class="_width _heigth"
              @click="change(3)">关注<span v-if="user_data.followCount" class="font-style">({{user_data.followCount}})</span>
            <div :class="menubox== 3 ? 'show_top':''"></div>
          </li>
          <li class="_width _heigth"
              @click="change(4)">粉丝<span v-if="user_data.fansCount" class="font-style">({{user_data.fansCount}})</span>
            <div :class="menubox== 4 ? 'show_top':''"></div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 内容 -->
    <div class="content _width">
      <div class="wrap ">
        <div v-show="menubox== 0">
          <Uworks></Uworks>
        </div>
        <div v-show="menubox== 1">
          <Ucircle @update_data="father_son_update"></Ucircle>
        </div>

        <div v-show="menubox== 2"
             @update_data="father_son_update">
          <photo_cover></photo_cover>
        </div>

        <div v-show="menubox== 3">
          <Ufollows @update_data="father_son_update"></Ufollows>
        </div>
        <div v-show="menubox== 4">
          <Ufans @update_data="father_son_update"></Ufans>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import communityHeader from '@/components/community/common/communityHeader.vue'
import Ucircle from '@/components/ucenter/Ucircle'
import Ufans from '@/components/ucenter/Ufans'
import Ufollows from '@/components/ucenter/Ufollows'
import Uworks from '@/components/ucenter/Uworks'
import photo_cover from '@/components/ucenter/photo_cover'
import Loading from '@/components/loading/loading.vue'
import {
  ta_ucenter_user,
  circle_follow,
  circle_deleteFollow
} from '@/utils/api/ucenter.js' //用户信息
import { Info } from '@/utils/api/login.js'


export default {
  name: "ucenter",
  data () {
    return {
      loading_bool: true, //加载loading
      menubox: '',
      user_data: [], //header 用户数据
      userId: '',
      imgUrl: 'https://v-pic.jingjiribao.cn/uploadPics/head/0CB94153211F4751BBA9D8026FB959C2.jpg'
    }
  },

  created () {
    let type = this.$route.query.type;
    if (type) {
      if (type == 0) {
        this.menubox = 0
      } else if (type == 1) {
        this.menubox = 1;
      } else if (type == 2) {
        this.menubox = 2;
      } else if (type == 3) {
        this.menubox = 3;
      } else if (type == 4) {
        this.menubox = 4;
      }
    }
    this.router_url = this.$route.fullPath;
    this.userId = this.$route.params && this.$route.params.id
    let params = {
      userId: this.userId,
    }
    this.header_ucenter_user(params); //用户基本细信息
    this.is_login();//是否登陆
    // this.menubox = 2
  },

  methods: {
    // // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
      })
    },

    // 父组件更新
    father_son_update () {
      let params = {
        userId: this.userId,
      }
      this.header_ucenter_user(params);
    },

    // 切换导航
    change (index) {
      this.menubox = index
      // if (index == 0) {
      //   this.$router.push(
      //     {
      //       path: '/Ucenter?type=0',
      //     }
      //   )
      // } else if (index == 1) {
      //   this.$router.push(
      //     {
      //       path: '/Ucenter?type=1',
      //     }
      //   )
      // } else if (index == 2) {
      //   this.$router.push(
      //     {
      //       path: '/Ucenter?type=2'
      //     }
      //   )
      // } else if (index == 3) {
      //   this.$router.push(
      //     {
      //       path: '/Ucenter?type=3'
      //     }
      //   )
      // } else if (index == 4) {
      //   this.$router.push(
      //     {
      //       path: '/Ucenter?type=4'
      //     }
      //   )
      // }
    },

    // 用户基本信息
    header_ucenter_user (name) {
      ta_ucenter_user(name).then((res) => {
        let data = res.data;
        this.user_data = data.data;
        document.title = '中经视觉-' + this.user_data.realname

        this.loading_bool = false;
      })
    },

    // 关注
    on_follow (id) {

      // 未登录就去登录
      if (this.isLogin == true) {
        let params = {
          followId: id,
        }
        circle_follow(params).then((res) => {
          let params_data = {
            userId: this.userId,
            current: 1,
            size: 10,
          }
          let data = res.data;
          this.follow_data = data;
          // 如果成功
          if (this.follow_data.code == 200) {
            this.header_ucenter_user(params_data);
            this.$message({
              message: '关注成功',
              type: 'success'
            });
          }
        })
      } else {
        sessionStorage.setItem('userId', this.userId)//用户信息 id
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }

    },
    // 取消关注
    deletd_follow (id) {

      // 未登录就去登录
      if (this.isLogin == true) {
        let params = {
          followId: id,
        }
        circle_deleteFollow(params).then((res) => {
          let params_data = {
            userId: this.userId,
            current: 1,
            size: 10,
          }
          let data = res.data;
          this.no_data = data;
          // 如果成功
          if (this.no_data.code == 200) {
            this.header_ucenter_user(params_data)
            this.$message({
              message: '取消关注成功',
              type: 'success'
            });
          }
        })
      } else {
        sessionStorage.setItem('userId', this.userId)//用户信息 id

        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },
  },

  components: {
    communityHeader,
    Ucircle,
    Ufans,
    Ufollows,
    Uworks,
    photo_cover,
    Loading
  }
}
</script>
<style scoped>
@import "../../assets/css/Ucenter/index.css";
.hover_foolow {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  height: 0.38rem;
}
.hover_foolow:hover {
  background-color: #f9fafb !important;
}
.hover_foolow div {
  display: flex;
  width: 100%;
  background-color: #f9fafb;
}
.top {
  position: absolute;
  top: 0.38rem;
  left: 0;
  width: 100%;
  transition: all 0.3s;
  text-align: center;
  display: flex;
  justify-content: center;
}
.hover_foolow:hover .top {
  top: 0;
}
.font-style {
  font-size: 0.12rem;
  color: #9f9d9d;

}
</style>



// WEBPACK FOOTER //
// src/views/community/Ucenter.vue